module.exports = __webpack_public_path__ + "static/media/stockhausen_blicke_79.ae2f1594.jpg";